import React, { useContext, useEffect, useState } from "react";
import ReactDOM from "react-dom/client";
import PropTypes from "prop-types";
import cn from "classnames";

import { Ad } from "@components/ad";
import { AdContext } from "@components/ad/context";
import { ReadMore } from "@components/readMore";

import styles from "./styles.module.css";

export function Body({ withReadMore = false, html }) {
  const ctx = useContext(AdContext);

  // Initialize roots as a state variable with an empty map
  const [roots, setRoots] = useState(new Map());

  useEffect(() => {
    const ads = document.querySelectorAll("div.ad-anchor");
    ads.forEach(ad => {
      const { auPath, placement } = ad.dataset;

      const rc = (
        <Ad
          path={auPath}
          placement={placement}
          white
          className="my-12 shadow p-6"
          contextOverride={ctx}
          native
        />
      );

      // Check if container already has a root by looking up in the `roots` map
      if (roots.has(ad)) {
        // Get the root object from the `roots` map
        const adRoot = roots.get(ad);
        // Render the Ad on the existing root
        adRoot.render(rc);
      } else {
        // If there is no root, create a new root
        const adRoot = ReactDOM.createRoot(ad);
        // Render the Ad on the new root
        adRoot.render(rc);
        // Add the new root object to the `roots` map
        // using the container element as the key
        // eslint-disable-next-line no-shadow
        setRoots(roots => new Map(roots).set(ad, adRoot));
      }
    });
  }, [ctx, roots]);

  return withReadMore ? (
    <ReadMore
      content={html}
      className={cn("lg:w-full", styles["article-body"])}
      wysiwyg={false}
      centered
    />
  ) : (
    <div
      className={cn("lg:w-full", styles["article-body"])}
      /* eslint-disable-next-line react/no-danger */
      dangerouslySetInnerHTML={{ __html: html }}
    />
  );
}

Body.propTypes = {
  html: PropTypes.string.isRequired,
  withReadMore: PropTypes.bool,
};
